// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1f-Qv","range":"MonthRangeSwitch_range__1yJX7","disabled":"MonthRangeSwitch_disabled__1XyBM"};